// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jMO9qV {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: var(--spacing-1);
}

.kP7WU1 {
  font-family: var(--font-family-base);
  font-weight: var(--type-paragraph-md-regular-font-weight);
  font-size: var(--type-paragraph-md-font-size);
  line-height: var(--type-paragraph-md-regular-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  height: 28px;
}

.WqHhGz {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-self: stretch;
  gap: var(--spacing-3);
}

.H8UAoD {
  display: flex;
  flex: 1;
  min-width: calc(50% - var(--spacing-3) / 2);
}

.H8UAoD.LMhUoc {
  flex-basis: 100%;
}

.XLgkiv {
  display: flex;
  flex: 1;
  min-width: calc(50% - var(--spacing-3) / 2);
  text-decoration: none;
  color: inherit;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.XLgkiv.LMhUoc {
  flex-basis: 100%;
}

.WqHhGz .XLgkiv:hover {
  transform: translateY(-2px);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);
}

.VFCLRo {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-2);
  padding: var(--spacing-2);
  background: var(--product-card-background);
  border-radius: var(--radius-s);
  box-shadow: var(--card-box-shadow);
  width: 100%;
  cursor: pointer;
}

.MowA0n {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background: #d64000;
  border-radius: 50%;
  flex-shrink: 0;
}

.MowA0n svg,
.MowA0n img {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}

.IPlJnm {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: var(--spacing-0-5);
  overflow: hidden;
}

.Z1XwSM {
  font-family: var(--font-family-base);
  font-weight: var(--type-label-sm-regular-font-weight);
  font-size: var(--type-label-sm-font-size);
  line-height: var(--type-label-sm-regular-line-height);
  color: var(--text-neutral-dark);
}

.rtJz1F {
  font-family: var(--font-family-base);
  font-weight: var(--type-subtitle-md-font-weight);
  font-size: var(--type-subtitle-md-font-size);
  line-height: var(--type-subtitle-md-line-height);
  color: var(--text-neutral-dark);
}

.IMtoT4 {
  color: #007aff;
  font-size: 12px;
  word-break: break-all;
}

@media (max-width: 768px) {
  .WqHhGz {
    gap: var(--spacing-2);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/ContactSection/ContactSection.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;EACzD,6CAA6C;EAC7C,yDAAyD;EACzD,+BAA+B;EAC/B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,2CAA2C;EAC3C,qBAAqB;EACrB,cAAc;EACd;;wBAEsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,0CAA0C;EAC1C,8BAA8B;EAC9B,kCAAkC;EAClC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,qDAAqD;EACrD,yCAAyC;EACzC,qDAAqD;EACrD,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,gDAAgD;EAChD,4CAA4C;EAC5C,gDAAgD;EAChD,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: var(--spacing-1);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-weight: var(--type-paragraph-md-regular-font-weight);\n  font-size: var(--type-paragraph-md-font-size);\n  line-height: var(--type-paragraph-md-regular-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  height: 28px;\n}\n\n.contactList {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-self: stretch;\n  gap: var(--spacing-3);\n}\n\n.contactWrapper {\n  display: flex;\n  flex: 1;\n  min-width: calc(50% - var(--spacing-3) / 2);\n}\n\n.contactWrapper.fullWidth {\n  flex-basis: 100%;\n}\n\n.contactLink {\n  display: flex;\n  flex: 1;\n  min-width: calc(50% - var(--spacing-3) / 2);\n  text-decoration: none;\n  color: inherit;\n  transition:\n    transform 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.contactLink.fullWidth {\n  flex-basis: 100%;\n}\n\n.contactList .contactLink:hover {\n  transform: translateY(-2px);\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);\n}\n\n.contactItem {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--spacing-2);\n  padding: var(--spacing-2);\n  background: var(--product-card-background);\n  border-radius: var(--radius-s);\n  box-shadow: var(--card-box-shadow);\n  width: 100%;\n  cursor: pointer;\n}\n\n.contactIcon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n  background: #d64000;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.contactIcon svg,\n.contactIcon img {\n  width: 16px;\n  height: 16px;\n  filter: brightness(0) invert(1);\n}\n\n.contactInfo {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n  gap: var(--spacing-0-5);\n  overflow: hidden;\n}\n\n.contactLabel {\n  font-family: var(--font-family-base);\n  font-weight: var(--type-label-sm-regular-font-weight);\n  font-size: var(--type-label-sm-font-size);\n  line-height: var(--type-label-sm-regular-line-height);\n  color: var(--text-neutral-dark);\n}\n\n.contactValue {\n  font-family: var(--font-family-base);\n  font-weight: var(--type-subtitle-md-font-weight);\n  font-size: var(--type-subtitle-md-font-size);\n  line-height: var(--type-subtitle-md-line-height);\n  color: var(--text-neutral-dark);\n}\n\n.contactEmail {\n  color: #007aff;\n  font-size: 12px;\n  word-break: break-all;\n}\n\n@media (max-width: 768px) {\n  .contactList {\n    gap: var(--spacing-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `jMO9qV`,
	"title": `kP7WU1`,
	"contactList": `WqHhGz`,
	"contactWrapper": `H8UAoD`,
	"fullWidth": `LMhUoc`,
	"contactLink": `XLgkiv`,
	"contactItem": `VFCLRo`,
	"contactIcon": `MowA0n`,
	"contactInfo": `IPlJnm`,
	"contactLabel": `Z1XwSM`,
	"contactValue": `rtJz1F`,
	"contactEmail": `IMtoT4`
};
module.exports = ___CSS_LOADER_EXPORT___;
